import { combineReducers } from 'redux';

import navigation from './reducers/goblinGourmetNavigationReducer';
import question from './reducers/goblinGourmetQuestionReducer';
import animation from './reducers/goblinGourmetAnimationReducer';
import audioSequence from './reducers/goblinGourmetAudioSequenceReducer';
import goblin from './reducers/goblinGourmetGoblinReducer';
import alex from './reducers/goblinGourmetAlexReducer';
import gameDetails from './reducers/goblinGourmetGameDetailsReducer';
import standardRound from './reducers/goblinGourmetStandardRoundReducer';
import savedData from './reducers/savedDataReducer';

export default combineReducers({
  alex,
  animation,
  audioSequence,
  goblin,
  gameDetails,
  navigation,
  question,
  savedData,
  standardRound,
});
